export default __webpack_public_path__ + "static/media/privacy-policy-title-cn.6344ebfa.webp";